// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 700px;
  margin: 0 auto;
}

.prediction-details {
  border: 2px solid #000;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
}

.report-title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  position: relative;
}

.underline {
  margin-top: 10px;
  margin-left: 0px;
  width: 100%;
  border: 1px solid #000;
  position: relative;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.logo-top-left {
  width: 50px;
  height: 50px;
}

.symbol-timestamp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.symbol {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.timestamp {
  font-size: 16px;
}

.prediction-details .content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.prediction-details p {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.prediction-details .label {
  color: #333;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
}

.prediction-details .value {
  color: #333;
}

.prediction-details .value.up {
  color: #4caf50;
}

.prediction-details .value.down {
  color: #f44336;
}

.prediction-details .profit {
  color: #4caf50;
}

.prediction-details .loss {
  color: #f44336;
}
`, "",{"version":3,"sources":["webpack://./src/Components/PredictionDetails.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".container {\r\n  max-width: 700px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.prediction-details {\r\n  border: 2px solid #000;\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.report-title {\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  margin-bottom: 10px;\r\n  position: relative;\r\n}\r\n\r\n.underline {\r\n  margin-top: 10px;\r\n  margin-left: 0px;\r\n  width: 100%;\r\n  border: 1px solid #000;\r\n  position: relative;\r\n}\r\n\r\n.report-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.logo-top-left {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.symbol-timestamp {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.symbol {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.timestamp {\r\n  font-size: 16px;\r\n}\r\n\r\n.prediction-details .content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.prediction-details p {\r\n  margin: 10px 0;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.prediction-details .label {\r\n  color: #333;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 15px;\r\n}\r\n\r\n.prediction-details .value {\r\n  color: #333;\r\n}\r\n\r\n.prediction-details .value.up {\r\n  color: #4caf50;\r\n}\r\n\r\n.prediction-details .value.down {\r\n  color: #f44336;\r\n}\r\n\r\n.prediction-details .profit {\r\n  color: #4caf50;\r\n}\r\n\r\n.prediction-details .loss {\r\n  color: #f44336;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
